import React, { useState, useCallback, useRef, useEffect } from 'react';
import { TemplatesApi } from '@apply/api';
import { applicationInsights } from '../../ApplicationInsights';
import { handleAdminError } from '../../common/SharedFunctions';
import { PreviewModal } from '../common/TemplateComponents';
import pretty from 'pretty';

export const HtmlEditor = ({ templateId, value, onChanged }) => {
    const templatesApi = new TemplatesApi.TemplatesApi(applicationInsights);

    const [openPreviewModal, set_openPreviewModal] = useState(false);
    const [previewData, set_previewData] = useState('');

    const htmlRef = useRef();

    useEffect(() => {
        htmlRef.current = pretty(value);
    }, [value]);

    const contentChanged = useCallback(
        (value) => {
            htmlRef.current = value;
            onChanged && onChanged(value);
        },
        [onChanged]
    );

    const onPreviewClick = async () => {
        try {
            const response = await templatesApi.previewTemplateHtml(templateId, htmlRef.current);
            set_previewData(response.result);
            set_openPreviewModal(true);
        } catch (ex) {
            handleAdminError(ex, 'Failed to retrieve Preview! Please try again.');
        }
    };

    return (
        <div>
            <button
                type='button'
                className='button hollow'
                onClick={onPreviewClick}
                style={{ padding: '10px', marginBottom: '5px', width: '100px' }}
            >
                Preview
            </button>
            <textarea
                value={htmlRef.current ?? ''}
                onChange={(e) => contentChanged(e.target.value)}
                style={{ height: '750px' }}
            />
            <PreviewModal
                isOpen={openPreviewModal}
                onClose={() => {
                    set_openPreviewModal(false);
                }}
                previewHtml={previewData.html}
                templateTypeId={previewData.templateTypeId}
                altContact={previewData.altContact}
                altCompany={previewData.altCompany}
                altAddress={previewData.altAddress}
            />
        </div>
    );
};
